// extracted by mini-css-extract-plugin
export default {"popper":"FilterPrice_popper__5m3vF","startInput":"FilterPrice_startInput__9ESiU","endInput":"FilterPrice_endInput__nQPMp"};